module.exports = __webpack_public_path__ + "3b80ead0ba27715568c74fa107d119d6.svg";